import React, { FC } from 'react';

import { SeoLocation } from '@rover/rsdk/src/apiClient/latest/model/seoLocation';

type Props = {
  seoLocation: SeoLocation;
};

// Placeholder for the pet grooming SEO location page. The container routes here when the
// backend names the `grooming` engine; the page itself is built in a later change.
const GroomingSeoLocationPageTemplate: FC<Props> = ({ seoLocation }) => (
  <pre>{JSON.stringify(seoLocation, null, 2)}</pre>
);

export default GroomingSeoLocationPageTemplate;
